import { Step, StepLabel, Stepper, Typography } from '@mui/material'
import { getPxAsRem } from 'shared/utils'

import type { FC } from 'react'

interface ProgressBarProps {
    steps: number
    currentStep: number
    handleStep: (step: number) => void
    intakeName: string
    skipIndex: number
}

export const ProgressBar: FC<ProgressBarProps> = ({
    steps,
    currentStep,
    handleStep,
    intakeName,
}) => {
    const stepIconSize = 24

    return (
        <>
            <Typography fontWeight={600}>
                {intakeName} · {Math.min(currentStep + 1, steps)} of {steps}
            </Typography>

            <Stepper
                activeStep={currentStep}
                alternativeLabel
                sx={{
                    // Apply some negative margins to align the stepper with the
                    // edges of the container despite the intrinsic white space
                    // from its flexbox layout.
                    marginTop: getPxAsRem(12),
                    marginX: `calc((100% / -${steps - 1} + ${stepIconSize}px) / 2)`,
                }}
            >
                {Array.from({ length: steps }, (_, index) => (
                    <Step
                        key={index}
                        onClick={() => handleStep(index)}
                        sx={{
                            cursor: 'pointer',

                            '& .MuiStepIcon-root': {
                                height: `${stepIconSize}px`,
                                width: `${stepIconSize}px`,
                            },
                        }}
                    >
                        <StepLabel></StepLabel>
                    </Step>
                ))}
            </Stepper>
        </>
    )
}
